import React from 'react';
import { Radar, RadarChart, PolarGrid, PolarAngleAxis, PolarRadiusAxis, ResponsiveContainer, Legend, Tooltip } from 'recharts';
import styles from './TacticalThemeRadarChart.module.css';

interface TacticalThemeDataPoint {
  subject: string;
  score: number;
  fullMark: number;
}

interface TacticalThemeRadarChartProps {
  data: TacticalThemeDataPoint[];
}

const TacticalThemeRadarChart: React.FC<TacticalThemeRadarChartProps> = ({ data }) => {
  if (!data || data.length === 0) {
    return <div className={styles.noData}>Intel on tactical theme proficiency is currently classified or unavailable. Awaiting field reports.</div>;
  }

  return (
    <ResponsiveContainer width="100%" height={300}>
      <RadarChart cx="50%" cy="50%" outerRadius="80%" data={data}>
        <PolarGrid />
        <PolarAngleAxis dataKey="subject" style={{ fontFamily: 'var(--font-primary, sans-serif)', fontSize: 'var(--text-sm, 0.875rem)' }} />
        <PolarRadiusAxis angle={30} domain={[0, 100]} style={{ fontFamily: 'var(--font-primary, sans-serif)', fontSize: 'var(--text-xs, 0.75rem)' }} />
        <Tooltip 
          contentStyle={{
            backgroundColor: 'var(--spy-light, #f8f8f8)',
            border: '1px solid var(--spy-dark, #555)',
            color: 'var(--spy-dark, #333)',
            fontFamily: 'var(--font-primary, sans-serif)'
          }}
        />
        <Radar name="Intel Level" dataKey="score" stroke="#1A3A63" /* themed: --spy-primary */ fill="#1A3A63" /* themed: --spy-primary */ fillOpacity={0.6} />
        <Legend wrapperStyle={{ fontFamily: 'var(--font-primary, sans-serif)' }} />
      </RadarChart>
    </ResponsiveContainer>
  );
};

export default React.memo(TacticalThemeRadarChart); 